export default function MbpButton() {
  return (
    <div className="position-relative ml-4">
      <a
        href="https://mbp.targetsmart.com/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <button
          className={"btn-primary py-2 px-3 border-0 rounded"}
          style={{ minWidth: "8em" }}
        >
          Remove Early Voters from Your Ads{" "}
        </button>
      </a>
    </div>
  );
}
